module.exports = __webpack_public_path__ + "img/ico_video_muted_on.6de0ceb.svg";